import React, { useContext } from "react";
import DropDownModalStyles from "../../Styles/ChannelViewer/DropDownModal.module.css";
import { ContextForClient } from "../../Context_file/ClientContext";
import Modal from "react-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHandshake,
  faPlus,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";

import Lists from "../../Common/List.component/List";

Modal.setAppElement("#root");

const DropDownModal = () => {
  const [{ DropDownModal }, dispatch] = useContext(ContextForClient);
  const { main, nav, list } = DropDownModalStyles;

  const customStyle = {
    content: {
      backgroundColor: "#000",
      borderRadius: "20px",
      width: "40%",
      height: "60%",
      minWidth: "300px",
    },
    overlay: {
      position: "absolute",
      zIndex: 10,
    },
  };

  const handleDropDown = ({ value }) => {
    switch (value.toLowerCase()) {
      case "join channel":
        dispatch({ type: "DISPLAY_CHANNELS_TO_JOIN", payload: true });
        break;

      case "create channel":
        dispatch({ type: "SHOW_MODAL", payload: true });
        break;

      default:
        break;
    }
  };

  const hideDropDown = async () => {
    await dispatch({ type: "SHOW_DROP_DOWN", payload: false });
  };

  return (
    <Modal
      isOpen={DropDownModal}
      shouldCloseOnEsc={false}
      onRequestClose={() => false}
      style={customStyle}
    >
      <main className={`container ${main}`}>
        <nav className={`text-capitalize ${nav}`}>
          {[
            { value: "join channel", icon: faHandshake },
            { value: "create channel", icon: faPlus },
          ].map(({ value, icon }, i) => (
            <figure className={`${list}`} key={i}>
              <Lists
                text={value}
                click={() => handleDropDown({ value })}
                color="#fff"
                cursor="pointer"
                className="me-2"
                listStyle="none"
              />
              <Lists
                text={<FontAwesomeIcon icon={icon} />}
                listStyle="none"
                color="#fff"
              />
            </figure>
          ))}
        </nav>

        <figure style={{ position: "absolute", top: "5%", right: "3%" }}>
          <FontAwesomeIcon
            icon={faTimesCircle}
            cursor="pointer"
            size="2x"
            color="#fff"
            onClick={() => hideDropDown()}
          />
        </figure>
      </main>
    </Modal>
  );
};

export default DropDownModal;
